import { RemoveFormatting } from "lucide-react";
import { KEYS } from "platejs";
import { useEditorRef } from "platejs/react";
import { memo, useCallback } from "react";
import { ToolbarButton } from "./toolbar";

const MARKS_TO_CLEAR = [
  KEYS.bold,
  KEYS.italic,
  KEYS.underline,
  KEYS.strikethrough,
  KEYS.color,
  KEYS.fontFamily,
  KEYS.fontSize,
] as const;

export const ClearFormattingToolbarButton = memo(
  function ClearFormattingToolbarButton() {
    const editor = useEditorRef();

    const handleClick = useCallback(() => {
      for (const mark of MARKS_TO_CLEAR) {
        editor.tf.removeMarks(mark);
      }
      editor.tf.focus();
    }, [editor]);

    return (
      <ToolbarButton
        Icon={RemoveFormatting}
        onClick={handleClick}
        tooltip="Clear formatting"
      />
    );
  },
);
